/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { connect }    from 'react-redux';
import { toggleMenu } from '../../store/actions';
import { Burger }     from '../../components/atoms/Burger';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const mapStateToProps = (state) => ({
    isNavigationOpen: state.isNavigationOpen
});

const mapDispatchToProps = (dispatch) => ({
    onBurgerClick: () => dispatch(toggleMenu())
});

export const NavigationBurger = connect(mapStateToProps, mapDispatchToProps)(Burger);



// WEBPACK FOOTER //
// ./src/containers/NavigationBurger/index.js